import React from "react";
import { Route, Routes } from "react-router-dom";
import ListCoupons from "../Components/Coupons/listCoupons";
import ViewCoupons from "../Components/Coupons/viewCoupons";
import AddCoupons from "../Components/Coupons/addCoupons";
import EditCoupons from "../Components/Coupons/editCoupons";

const CouponsRoutes = () => {
  return (
    <Routes>
      <Route
        path="/create_coupons"
        element={<ListCoupons></ListCoupons>}
      ></Route>
      <Route
        path="/create_coupons/view/:id"
        element={<ViewCoupons></ViewCoupons>}
      ></Route>
      <Route
        path="/create_coupons/add"
        element={<AddCoupons></AddCoupons>}
      ></Route>
      <Route
        path="/create_coupons/edit/:id"
        element={<EditCoupons></EditCoupons>}
      ></Route>
    </Routes>
  );
};

export default CouponsRoutes;
